import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "environments/environment";

export interface MaintenanceWindow {
    maintenance_id: string;
    services: string[];
    reason: string;
    operator: string;
    scheduled: boolean;
    expected_duration_sec: number | null;
    started_at: string;
    ended_at: string | null;
    duration_sec: number | null;
    command?: string;
}

export interface MaintenanceActiveResponse {
    success: boolean;
    data: MaintenanceWindow[];
}

export interface MaintenanceRecentResponse {
    success: boolean;
    data: MaintenanceWindow[];
}

@Injectable({
    providedIn: 'root'
})
export class SystemHealthService {
    constructor(private http: HttpClient) { }

    getSystemHealth(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/system/health`);
    }

    // ── VMS Maintenance APIs ─────────────────────────────────────────────────

    getMaintenanceActive(): Observable<MaintenanceActiveResponse> {
        // Tạm thời comment API thực tế để không bắn HTTP request ngầm
        return of({ success: true, data: [] });
        // return this.http.get<MaintenanceActiveResponse>(`${environment.apiUrl}/vms/system/maintenance/active`);
    }

    getMaintenanceRecent(params?: { since?: string; limit?: number }): Observable<MaintenanceRecentResponse> {
        let httpParams = new HttpParams();
        if (params?.since) httpParams = httpParams.set('since', params.since);
        if (params?.limit) httpParams = httpParams.set('limit', params.limit.toString());
        return this.http.get<MaintenanceRecentResponse>(`${environment.apiUrl}/vms/system/maintenance/recent`, { params: httpParams });
    }
}